module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"labelZoom":"Niveau de zoom"},"en":{"labelZoom":"Zoom level"}}')
  delete Component.options._Ctor
}
